"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const use_debounce_1 = require("use-debounce");
const react_2 = require("@ag-grid-community/react");
const client_side_row_model_1 = require("@ag-grid-community/client-side-row-model");
const range_selection_1 = require("@ag-grid-enterprise/range-selection");
const clipboard_1 = require("@ag-grid-enterprise/clipboard");
const side_bar_1 = require("@ag-grid-enterprise/side-bar");
const column_tool_panel_1 = require("@ag-grid-enterprise/column-tool-panel");
const filter_tool_panel_1 = require("@ag-grid-enterprise/filter-tool-panel");
const rich_select_1 = require("@ag-grid-enterprise/rich-select");
const master_detail_1 = require("@ag-grid-enterprise/master-detail");
const status_bar_1 = require("@ag-grid-enterprise/status-bar");
const set_filter_1 = require("@ag-grid-enterprise/set-filter");
const menu_1 = require("@ag-grid-enterprise/menu");
const multi_filter_1 = require("@ag-grid-enterprise/multi-filter");
const excel_export_1 = require("@ag-grid-enterprise/excel-export");
require("@ag-grid-community/core/dist/styles/ag-grid.css");
require("@ag-grid-community/core/dist/styles/ag-theme-balham.css");
const api_1 = __importStar(require("../../api"));
const PlantsColumns_1 = require("./PlantsColumns");
const GridColumnTypes_1 = __importDefault(require("../Common/GridColumnTypes"));
const ViewsToolPanelComponent_1 = __importDefault(require("../ToolPanels/ViewsToolPanelComponent"));
const errorNotification_1 = require("../../errorNotification");
const NewColumnToolPanelComponent_1 = __importDefault(require("../ToolPanels/NewColumnToolPanelComponent"));
const use_pusher_1 = require("@harelpls/use-pusher");
const AuthContext_1 = require("../../Auth/AuthContext");
const utils_1 = require("../utils");
const NumericEditorReact_1 = __importDefault(require("../Editors/NumericEditorReact"));
const StatusBarComponent_1 = __importDefault(require("../StatusBarComponent"));
const NewPlantForm_1 = __importDefault(require("../../forms/NewPlantForm"));
const MultiSelectCellEditorReact_1 = __importDefault(require("../Editors/MultiSelectCellEditorReact"));
const WidthRichSelectCellEditor_1 = __importDefault(require("../Editors/WidthRichSelectCellEditor"));
const Button_1 = __importDefault(require("../../forms/Button"));
const Modal_1 = __importDefault(require("../Modal"));
const query_string_1 = __importDefault(require("query-string"));
const quickOrderedFilter_1 = require("../quickOrderedFilter");
const gridUtils_1 = require("../gridUtils");
const DetailPicturesCellRenderer_1 = __importDefault(require("../Renderers/DetailPicturesCellRenderer"));
const gridLocale_de_1 = __importDefault(require("../gridLocale.de"));
const DuplicateTextCellEditor_1 = require("../Editors/DuplicateTextCellEditor");
const utils_2 = require("../../Auth/utils");
const IsAllowed_1 = __importDefault(require("../../Auth/IsAllowed"));
const pusherEvents_1 = require("../Common/pusherEvents");
const permissions_1 = require("../../types/permissions");
var quickFilterParsedValue = [];
const PlantsGrid = () => {
    const [gridClientID,] = (0, react_1.useState)((0, pusherEvents_1.generateGridClientId)('plants'));
    const [gridApi, setGridApi] = (0, react_1.useState)(null);
    const [, setGridColumnApi] = (0, react_1.useState)(null);
    const [rows,] = (0, react_1.useState)([]);
    const [columns,] = (0, react_1.useState)([]);
    const [presets,] = (0, react_1.useState)({});
    const [newItemModalOpened, setNewItemModalOpened] = (0, react_1.useState)(false);
    const [isUserEditingGrid, setIsUserEditingGrid] = (0, react_1.useState)(false);
    const [remoteTransactionsQueue, setRemoteTransactionsQueue] = (0, react_1.useState)([]);
    const [quickFilterText, setQuickFilterText] = (0, react_1.useState)('');
    const [debouncedQuickFilterText] = (0, use_debounce_1.useDebounce)(quickFilterText, 300);
    const api = new api_1.default;
    const plantApi = new api_1.PlantApi(undefined, gridClientID);
    const { user } = (0, AuthContext_1.useAuth)();
    const createGridTransaction = (data, metadata) => {
        // checking grid client ID to avoid applying updates from the same client grid
        if (data.gridClientId === gridClientID) {
            return null;
        }
        // if the update is from the same user dont do anything
        const itemsToAdd = data.add;
        // map changes to updatable grid nodes, update only fields that changed to avoid conflicts
        const itemsToUpdate = data.update.map(change => {
            const rowNode = gridApi.getRowNode(String(change.id));
            return { ...rowNode.data, ...change.attributes };
        });
        const itemsToRemove = data.remove.map(r => {
            return gridApi.getRowNode(String(r));
        });
        return {
            add: itemsToAdd,
            update: itemsToUpdate,
            remove: itemsToRemove
        };
    };
    const channel = (0, use_pusher_1.useChannel)("presence-plants");
    (0, use_pusher_1.useEvent)(channel, 'plants.changed', (0, pusherEvents_1.proccessPusherEvents)(user, createGridTransaction, gridApi, isUserEditingGrid, { queue: remoteTransactionsQueue, setQueue: setRemoteTransactionsQueue }));
    (0, react_1.useEffect)(() => {
        if (!isUserEditingGrid) {
            (0, pusherEvents_1.applyGridTransactions)(gridApi, [...remoteTransactionsQueue]);
            setRemoteTransactionsQueue(() => []);
        }
    }, [isUserEditingGrid]);
    // external filter changed
    (0, react_1.useEffect)(() => {
        quickFilterParsedValue = debouncedQuickFilterText ? debouncedQuickFilterText.toString().toLowerCase().split(' ') : [];
        if (gridApi)
            gridApi.onFilterChanged();
    }, [debouncedQuickFilterText]);
    const defaultColDef = {
        flex: 1,
        minWidth: 75,
        filter: true,
        editable: (params) => {
            if (!(0, utils_2.isAllowed)(user, ['update_plant'])) {
                return false;
            }
            if (params.column.getColId() === 'wachstum') {
                return (0, utils_2.hasRole)(user, ['admin']);
            }
            if (params.data.label_confirmed && (0, gridUtils_1.isGridColumnOfType)(params.column, 'perm_editConfirmedLabel')) {
                return (0, utils_2.isAllowed)(user, [permissions_1.GridPermissions.EDIT_CONFIRMED_LABEL]);
            }
            return (0, utils_2.isAllowed)(user, ['update_plant']);
        },
        resizable: true,
        sortable: true,
        floatingFilter: true,
        enablePivot: false,
        enableValue: false,
        enableRowGroup: false,
        cellClass: 'default',
    };
    const sideBarDef = {
        toolPanels: [
            {
                id: 'columns',
                labelDefault: 'Columns',
                labelKey: 'columns',
                iconKey: 'columns',
                toolPanel: 'agColumnsToolPanel',
                toolPanelParams: {
                    suppressRowGroups: true,
                    suppressValues: true,
                    suppressPivots: true,
                    suppressPivotMode: true,
                    suppressSideButtons: false,
                    suppressColumnExpandAll: true,
                },
            },
            {
                id: 'views',
                labelDefault: 'Views',
                labelKey: 'views',
                iconKey: '',
                toolPanel: 'viewsToolPanel',
                toolPanelParams: {
                    gridModel: 'Plant',
                }
            },
        ],
        defaultToolPanel: 'columns',
    };
    const gridModules = [
        range_selection_1.RangeSelectionModule,
        client_side_row_model_1.ClientSideRowModelModule,
        clipboard_1.ClipboardModule,
        side_bar_1.SideBarModule,
        column_tool_panel_1.ColumnsToolPanelModule,
        filter_tool_panel_1.FiltersToolPanelModule,
        rich_select_1.RichSelectModule,
        master_detail_1.MasterDetailModule,
        status_bar_1.StatusBarModule,
        set_filter_1.SetFilterModule,
        multi_filter_1.MultiFilterModule,
        excel_export_1.ExcelExportModule,
        menu_1.MenuModule,
    ];
    function onGridReady(params) {
        setGridApi(params.api);
        setGridColumnApi(params.columnApi);
        const fetchData = async () => {
            params.api.showLoadingOverlay();
            const api = new api_1.default();
            try {
                const data = await api.getPlants();
                params.api.setColumnDefs((0, PlantsColumns_1.createColumn)(data.columns, data.presets));
                params.api.setRowData(data.plants);
            }
            catch (e) {
                if (e.response.status === 403) {
                    (0, errorNotification_1.notifyError)(e.response.data.message);
                }
                else {
                    (0, errorNotification_1.notifyError)(e.message);
                }
            }
            params.api.hideOverlay();
        };
        fetchData().then(() => { });
    }
    const firstDataRendered = (event) => {
        event.columnApi.autoSizeAllColumns(true);
    };
    const doesExternalFilterPass = (node) => {
        return (0, quickOrderedFilter_1.quickOrderedFilter)((node.data['botanisch_slugged'] || '').split("-"), quickFilterParsedValue);
    };
    const isExternalFilterPresent = () => {
        return quickFilterParsedValue.length > 0;
    };
    const gridOptions = {
        enableRangeSelection: true,
        getRowNodeId: (data) => {
            return data.id;
        },
        isExternalFilterPresent: isExternalFilterPresent,
        doesExternalFilterPass: doesExternalFilterPass,
        detailCellRenderer: 'DetailPicturesCellRenderer',
        excelStyles: [
            {
                id: 'default',
                font: {
                    fontName: 'Arial',
                    size: 10,
                }
            },
            {
                id: 'derived',
                font: {
                    fontName: 'Arial',
                    size: 10,
                }
            },
            {
                id: 'header',
                font: {
                    fontName: 'Arial',
                    size: 10,
                }
            }
        ],
    };
    const statusBar = {
        statusPanels: [
            {
                statusPanel: 'StatusBarComponent',
                statusPanelParams: {
                    channelName: 'presence-plants',
                },
            },
        ],
    };
    const updatePlants = async (updates) => {
        // check for duplication
        try {
            const { success, changes } = await api.bulkUpdatePlant(updates);
            changes.map(change => {
                const rowNode = gridApi.getRowNode(change.id);
                const update = updates.find(o => o.id === change.id);
                for (const [column, value] of Object.entries(change)) {
                    if (update.column !== column && gridApi.getColumnDef(column) !== null) {
                        rowNode.setDataValue(column, value);
                    }
                }
            });
        }
        catch (e) {
            if (e.response.status === 403) {
                (0, errorNotification_1.notifyError)(e.response.data.message);
            }
            else {
                (0, errorNotification_1.notifyError)(e.message);
            }
        }
    };
    const debouncedUpdate = (0, utils_1.debounceAgg)(updatePlants, 250);
    const cellValueChanged = async (event) => {
        const { data } = event;
        const { newValue = null, oldValue = null } = event;
        if (newValue === oldValue) {
            return;
        }
        const isEditable = event.column.isCellEditable(event.node);
        if (isEditable) {
            const column = event.column.getColId();
            const { id } = data;
            try {
                debouncedUpdate({ id, column, value: newValue });
            }
            catch (e) {
                (0, errorNotification_1.notifyError)(e.message);
            }
        }
    };
    const duplicateRecord = async (a) => {
        const rows = a.getSelectedNodes();
        if (rows.length === 0) {
            (0, errorNotification_1.notify)('error', 'Keine Datensätze zur Vervielfältigung ausgewählt!');
            return;
        }
        if (rows.length > 1) {
            (0, errorNotification_1.notify)('error', 'Wählen Sie nur 1 Datensatz zum Duplizieren aus!');
            return;
        }
        try {
            const [rowToDuplicate] = rows;
            const { success, record } = await plantApi.duplicate(rowToDuplicate.data.id);
            if (success) {
                const transaction = a.applyTransaction({ addIndex: rowToDuplicate.rowIndex + 1, add: [record] });
                (0, errorNotification_1.notify)('success', 'Zeile dupliziert.');
                const [addedRow] = transaction.add;
                a.flashCells({ rowNodes: [addedRow] });
            }
        }
        catch (e) {
            (0, errorNotification_1.notifyError)(e);
            (0, errorNotification_1.notifyError)(e.response.data.message);
        }
    };
    const deleteRecords = async (a) => {
        const rows = a.getSelectedNodes();
        if (rows.length === 0) {
            (0, errorNotification_1.notify)('error', 'Keine Datensätze zu Löschen ausgewählt!');
            return;
        }
        const ids = rows.map(row => row.data.id).join(', ');
        if (confirm(`Möchten Sie diese Datensatz-ID wirklich löschen: ${ids}?`)) {
            try {
                const { success } = await plantApi.deletePlants(rows.map((row) => row.id));
                if (success)
                    a.applyTransaction({ remove: rows });
            }
            catch (error) {
                (0, errorNotification_1.notifyError)(error);
            }
        }
    };
    const exportPictures = (a) => {
        const rows = a.getSelectedNodes();
        if (rows.length === 0) {
            (0, errorNotification_1.notify)('error', 'Keine Datensätze ausgewählt!');
            return;
        }
        if (rows.length > 50) {
            (0, errorNotification_1.notify)('error', "Es können nur Bilder von bis zu 50 Pflanzen exportiert werden.");
            return;
        }
        const stringified = query_string_1.default.stringify({
            modelIds: rows.map(row => row.data.id),
        }, { arrayFormat: 'comma' });
        location.assign(`/api/images/export?${stringified}`);
    };
    const handleNewPlant = (record) => {
        const transaction = gridApi.applyTransaction({ addIndex: 0, add: [record] });
        const [addedRow] = transaction.add;
        gridApi.ensureNodeVisible(addedRow, 'top');
        gridApi.flashCells({ rowNodes: [addedRow] });
        setNewItemModalOpened(false);
    };
    const handleExcelExport = () => {
        const columnKeys = gridApi
            .getColumnDefs()
            .filter((col) => {
            return col.field !== 'perennials_practice';
        })
            .map((col) => { return col.field ? col.field : ''; })
            .filter((value) => value !== '');
        const params = {
            fileName: 'Pflanzen_export',
            sheetName: 'Sheet1',
            onlySelected: true,
            columnKeys: columnKeys,
        };
        gridApi.exportDataAsExcel(params);
    };
    const resetFilters = () => {
        gridApi.setFilterModel(null);
        setQuickFilterText('');
        gridApi.onFilterChanged();
    };
    const cellEditingStarted = (e) => {
        setIsUserEditingGrid(true);
    };
    const cellEditingStopped = (e) => {
        setIsUserEditingGrid(false);
    };
    const getContextMenuItems = (params) => {
        return [
            (0, utils_2.isAllowed)(user, ['update_plant']) ? {
                name: 'Wert "' + params.value + '" für markierte Zeilen übernehmen',
                action: function () {
                    const rows = params.api.getSelectedNodes();
                    rows.forEach(row => {
                        if (!params.column.isCellEditable(row)) {
                            return;
                        }
                        row.setDataValue(params.column, params.value);
                    });
                },
            } : '',
            'copy',
            (0, utils_2.isAllowed)(user, ['create_plant']) ? 'separator' : '',
            (0, utils_2.isAllowed)(user, ['create_plant']) ? {
                name: 'Zeile duplizieren',
                action: function () {
                    duplicateRecord(params.api);
                }
            } : '',
            (0, utils_2.isAllowed)(user, ['delete_plant']) ? {
                name: 'Zeilen löschen',
                action: function () {
                    deleteRecords(params.api);
                },
            } : '',
            (0, utils_2.isAllowed)(user, ['export_pictures']) ? 'separator' : '',
            (0, utils_2.isAllowed)(user, ['export_pictures']) ? {
                name: 'Bilder exportieren',
                action: function () {
                    exportPictures(params.api);
                }
            } : '',
        ];
    };
    const getRowClassRules = {
        'checked': (params) => params.data.label_confirmed,
    };
    const gridTable = react_1.default.useMemo(() => {
        return (react_1.default.createElement(react_2.AgGridReact
        // @ts-ignore
        , { 
            // @ts-ignore
            modules: gridModules, localeText: gridLocale_de_1.default, columnTypes: GridColumnTypes_1.default, disableStaticMarkup: true, onGridReady: onGridReady, onFirstDataRendered: firstDataRendered, onCellKeyDown: gridUtils_1.onCellKeyDown, rowSelection: 'multiple', suppressCopyRowsToClipboard: true, enableRangeSelection: true, undoRedoCellEditing: true, enableCellChangeFlash: true, animateRows: true, enableFillHandle: true, fillHandleDirection: 'y', rowClassRules: getRowClassRules, gridOptions: gridOptions, defaultColDef: defaultColDef, sideBar: sideBarDef, getRowNodeId: (data) => data.id, masterDetail: true, onCellEditingStarted: cellEditingStarted, onCellEditingStopped: cellEditingStopped, getContextMenuItems: getContextMenuItems, onCellValueChanged: cellValueChanged, frameworkComponents: {
                viewsToolPanel: ViewsToolPanelComponent_1.default,
                newColumnToolPanel: NewColumnToolPanelComponent_1.default,
                StatusBarComponent: StatusBarComponent_1.default,
                NumericEditor: NumericEditorReact_1.default,
                MultiSelectCellEditorReact: MultiSelectCellEditorReact_1.default,
                DetailPicturesCellRenderer: DetailPicturesCellRenderer_1.default,
            }, components: {
                DuplicateTextCellEditor: DuplicateTextCellEditor_1.DuplicateTextCellEditor,
                WidthRichSelectCellEditor: WidthRichSelectCellEditor_1.default,
            }, suppressLastEmptyLineOnPaste: true, statusBar: statusBar }));
    }, [rows, columns, gridApi]);
    return (react_1.default.createElement("div", { id: 'plants-grid', className: "ag-theme-balham flex flex-col w-full" },
        react_1.default.createElement("div", { className: 'mb-2 flex items-end space-x-4' },
            react_1.default.createElement("div", { className: 'max-w-lg' },
                react_1.default.createElement("input", { type: "text", id: "filter-text-box", className: 'form-input', placeholder: "Suche...", value: quickFilterText, onChange: e => setQuickFilterText(e.target.value) })),
            react_1.default.createElement("div", { className: 'space-x-2 flex flex-1' },
                react_1.default.createElement(IsAllowed_1.default, { permissions: ['create_plant'] },
                    react_1.default.createElement(Button_1.default, { onClick: () => setNewItemModalOpened(true) }, "Neue Pflanze")),
                react_1.default.createElement(IsAllowed_1.default, { permissions: ['delete_plant'] },
                    react_1.default.createElement(Button_1.default, { onClick: () => deleteRecords(gridApi) }, "Zeilen l\u00F6schen")),
                react_1.default.createElement(IsAllowed_1.default, { permissions: ['create_plant'] },
                    react_1.default.createElement(Button_1.default, { onClick: () => duplicateRecord(gridApi) }, "Zeile duplizieren")),
                react_1.default.createElement(IsAllowed_1.default, { permissions: ['export_pictures'] },
                    react_1.default.createElement(Button_1.default, { onClick: () => exportPictures(gridApi), title: 'Exportiert Bilder von ausgewählten Pflanzen' }, "Bilder exportieren")),
                react_1.default.createElement(IsAllowed_1.default, { permissions: ['export_excel'] },
                    react_1.default.createElement(Button_1.default, { onClick: () => handleExcelExport(), title: "" }, "Excel-Export"))),
            react_1.default.createElement("div", { className: 'space-x-1' },
                react_1.default.createElement(Button_1.default, { onClick: () => resetFilters(), size: 'sm', variant: 'white' }, "Filter zur\u00FCcksetzen"),
                react_1.default.createElement(Button_1.default, { onClick: () => gridApi.undoCellEditing(), size: 'sm', variant: 'white' }, "Undo"),
                react_1.default.createElement(Button_1.default, { onClick: () => gridApi.redoCellEditing(), size: 'sm', variant: 'white' }, "Redo"))),
        gridTable,
        react_1.default.createElement(Modal_1.default, { isOpen: newItemModalOpened, onRequestClose: () => { setNewItemModalOpened(false); } },
            react_1.default.createElement(NewPlantForm_1.default, { presets: presets, handleNewPlant: handleNewPlant, plantApi: plantApi }))));
};
exports.default = PlantsGrid;
